import gql from 'graphql-tag';

export const GET_PARTNER_LINKS = gql`
  query GetPartnerLinks(
    $dynamicsId: ID!
    $metricsDateRange: PartnerLinksMetricsDateRangeInput
    $limit: Int
    $offset: Int
  ) {
    getPartnerLinks(dynamicsId: $dynamicsId, metricsDateRange: $metricsDateRange, limit: $limit, offset: $offset) {
      partnerLinkId
      dynamicsPartnerAccountId
      dynamicsPartnerLinkId
      accountId
      accountName
      integrationSettingsValues {
        integrationSettingsValues
      }
      partnerLocations {
        locationId
        locationName
        category
      }
      metrics {
        status
        activeMenus
        totalSent
        totalSold
        soldRetailPrice
      }
    }
  }
`;
